import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * HTTP Interceptor for Ideal Postcodes API requests.
 *
 * Appends the API key to any request bound for the address-lookup service, so
 * third-party keys are applied in one layer rather than at each call site.
 * Mirrors nextBillionApiInterceptor.
 *
 * Note: these lookups are billable per request. Keeping them on Angular's
 * HttpClient (rather than a bundled widget with its own HTTP stack) is what
 * makes this interceptor — and the cache in AddressLookup — possible.
 */
export const idealPostcodesApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('api.ideal-postcodes.co.uk')) {
    const modifiedReq = req.clone({
      setParams: {
        api_key: environment.idealPostcodes.apiKey,
      },
    });
    return next(modifiedReq);
  }

  return next(req);
};
